import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from 'react';
import { OTErrorBlock } from '../ot-error';
import { AccordionWithValidation } from 'z3k-settings/components/material-utils/accordion-with-validation';
import { alpha, Box, Button, Typography } from '@mui/material';
export const BoilerFailPane = memo(function BoilerFailPane(props) {
    const { fail, name, ot_state, boiler_model, ba_protocol, onClick } = props;
    //контур имеет флаг ошибки или в OT есть ошибка
    if (!fail) {
        return null;
    }
    return (_jsx(AccordionWithValidation, { header: _jsx(Box, { display: "flex", flexGrow: 1, justifyContent: "center", children: _jsxs(Typography, { fontWeight: "500", fontSize: 18, children: ["\u0410\u0432\u0430\u0440\u0438\u044F \u043A\u043E\u0442\u043B\u0430 (", name, ")"] }) }), validation_result: null, validation_warnings_result: null, headerProps: {
            sx: {
                color: 'error.contrastText',
                bgcolor: 'error.main',
                '& .MuiSvgIcon-root, & .material-dnd': {
                    color: 'error.contrastText',
                },
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            },
        }, detailsProps: {
            sx: {
                color: 'error.contrastText',
                bgcolor: 'error.main',
                '& .MuiSvgIcon-root, & .material-dnd': {
                    color: 'error.contrastText',
                },
            },
        }, sx: {
            borderBottom: `1px solid divider`,
            textAlign: ' center',
        }, children: ot_state != null && (_jsxs(_Fragment, { children: [_jsx(OTErrorBlock, { ot: ot_state, ba_protocol: ba_protocol, boiler_model: boiler_model }), _jsxs(Button, { onClick: onClick, color: "info", variant: "outlined", sx: (theme) => ({
                        color: theme.palette.common.white,
                        border: `1px solid ${theme.palette.common.white}`,
                        '&:hover, &.Mui-focusVisible': {
                            border: `1px solid ${theme.palette.common.white}`,
                            backgroundColor: alpha(theme.palette.common.white, 0.1),
                        },
                    }), children: ["\u0421\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435 \u043A\u043E\u0442\u043B\u0430 (", name, ")"] })] })) }));
});
